import type { FormValues } from '../../../SamplesOrders.types'
import type { Item, SelectedItem } from '../SelectItems.types'
import { isOfferItemType } from './isOfferItemType'

const getSelectedItemPrice = (variantId: string, items: Item[]) => {
  const itemWithPrice = items.find((item) => 'variantId' in item && item.variantId === variantId)

  if (!itemWithPrice || isOfferItemType(itemWithPrice)) return undefined

  return itemWithPrice.price
}

export const getInitialSelectedItems = (initialValues: FormValues, items: Item[]) =>
  initialValues.items.reduce<SelectedItem[]>(
    (acc, { variantId, quantity }) => [
      ...acc,
      {
        variantId,
        quantity: quantity.toString(),
        price: getSelectedItemPrice(variantId, items),
      },
    ],
    [],
  )
